"use client";

import React from "react";
import { ArrowRight, Disc, Truck } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardDescription, CardTitle } from "@/components/ui/card";
export default function TireServices() {
  const serviceCards = [{
    id: "flat-repair",
    title: "Flat tire repair",
    subtitle: "In-shop & rapid puncture fixes",
    description: "Quick inspection, professional patch-and-plug repairs, and tire pressure diagnostics to get you safely back on the road.",
    href: "/flat-tire-repair-los-angeles/",
    buttonText: "Explore flat tire repair",
    icon: Disc
  }, {
    id: "mobile-service",
    title: "Mobile tire service",
    subtitle: "We come directly to your location",
    description: "We come to you — service at your home, work, or roadside location.",
    href: "/mobile-tire-service-los-angeles/",
    buttonText: "Explore mobile tire service",
    icon: Truck
  }];
  return <section id="moretireservices" data-nav="light" className="bg-background py-8 sm:py-11 md:py-14">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="mx-auto max-w-2xl text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            More tire services
          </h2>
          <p className="mt-3 text-base text-muted-foreground sm:text-lg">
            Choose the service that fits your situation best.
          </p>
        </motion.div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8">
          {serviceCards.map((service, i) => {
          const IconComponent = service.icon;
          return <motion.div key={service.id} data-index={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1,
            ease: "easeOut"
          }} className="h-full">
                <Card className="group flex h-full flex-col justify-between gap-4 rounded-xl border border-border bg-card p-5 shadow-sm transition-[border-color,box-shadow] duration-200 hover:border-primary/50 hover:shadow-md sm:flex-row sm:items-start sm:gap-5 sm:p-6">
                  <div className="shrink-0">
                    <div className="inline-flex size-11 items-center justify-center rounded-lg bg-accent text-accent-foreground sm:size-12">
                      <IconComponent className="size-5 text-primary sm:size-6" aria-hidden="true" />
                    </div>
                  </div>

                  <div className="flex flex-1 flex-col justify-between">
                    <div>
                      <CardTitle className="font-default text-xl font-bold text-card-foreground sm:text-2xl">
                        {service.title}
                      </CardTitle>
                      <p className="mt-1 text-sm font-medium text-primary">
                        {service.subtitle}
                      </p>
                      <CardDescription className="mt-2 text-sm leading-relaxed text-muted-foreground sm:text-base">
                        {service.description}
                      </CardDescription>
                    </div>

                    <div className="mt-4 pt-1">
                      <Button asChild variant="default" size="sm" className="inline-flex items-center gap-2 font-semibold">
                        <Link to={service.href}>
                          <span>{service.buttonText}</span>
                          <ArrowRight className="size-4 transition-[transform] duration-200 group-hover:translate-x-1" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </Card>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}